import type { UserSessionData } from 'noddi-web';
import { useUserGroupDialogActions } from '../stores/userGroupDialogStore';
import { getSelectableUserGroups } from '../utils/userGroupContext';

/** After a login mid-flow, lets an account with several profiles pick one. */
export const useOpenUserGroupPickerAfterLogin = () => {
  const { openUserGroupDialog } = useUserGroupDialogActions();

  return (userData: UserSessionData) => {
    if (getSelectableUserGroups(userData).length > 1) {
      // Logging in mid-flow must not drop the booking draft it was started from.
      openUserGroupDialog({ keepBookingDrafts: true });
    }
  };
};
